import { create } from "zustand"
import { persist } from "zustand/middleware"

export const MAX_AUTO_REVIEWED_THREADS = 500

interface EscalationReviewState {
	// Threads the assistant already opened a review on, oldest first.
	autoReviewedThreadIds: string[]
	hasAutoReviewed: (threadId: string) => boolean
	markAutoReviewed: (threadId: string) => void
}

export function appendCapped(
	ids: string[],
	id: string,
	max = MAX_AUTO_REVIEWED_THREADS,
): string[] {
	const next = [...ids.filter((existing) => existing !== id), id]
	return next.length > max ? next.slice(next.length - max) : next
}

export const useEscalationReviewState = create<EscalationReviewState>()(
	persist(
		(set, get) => ({
			autoReviewedThreadIds: [],
			hasAutoReviewed: (threadId) =>
				get().autoReviewedThreadIds.includes(threadId),
			markAutoReviewed: (threadId) =>
				set({
					autoReviewedThreadIds: appendCapped(
						get().autoReviewedThreadIds,
						threadId,
					),
				}),
		}),
		{
			name: "escalation-review-state",
			partialize: (state) => ({
				autoReviewedThreadIds: state.autoReviewedThreadIds,
			}),
		},
	),
)
